import { motion } from "framer-motion";
import Grid from "../Grid/grid";
import products from "./data/product-data";
import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Title from "../title";
import { useNavigate } from "react-router-dom";

function OurProducts() {
  const [active, setActive] = useState(0);
  const navigate = useNavigate();
  const displayProducts = [...products, products[0]];

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev === products.length - 1 ? 0 : prev + 1));
    }, 4000);

    return () => clearInterval(interval);
  }, [active]);
  return (
    <section className="w-full min-h-screen h-full overflow-hidden relative flex flex-col lg:p-16 p-8">
      <Grid direction="top-center" size={100} />
      <div className="z-10 flex flex-wrap justify-between items-start gap-4">
        <Title title="Our Products" />
        <div className="flex-row gap-2 flex items-end justify-end md:w-auto w-full">
          <button
            onClick={() => setActive(active === 0 ? products.length - 1 : active - 1)}
            className={`${products[active].color} hover:${products[active].color}/60 outline-none text-white rounded-full p-2 transition-colors duration-300`}
            aria-label="Previous product"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <button
            onClick={() => setActive(active === products.length - 1 ? 0 : active + 1)}
            className={`${products[active].color} hover:${products[active].color}/60 outline-none text-white rounded-full p-2 transition-colors duration-300`}
            aria-label="Next product"
          >
            <ChevronRight className="w-6 h-6" />
          </button>
        </div>
      </div>
      <div className="flex h-full md:p-10 py-10">
        <motion.div
          className="flex flex-col w-full h-full gap-2"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="flex md:flex-row flex-col items-center justify-between my-5 gap-3">
            <motion.div
              className="flex flex-col items-start justify-center gap-4 "
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            >
              <motion.h2
                className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 transition-all duration-500 ease-in-out"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                {products[active].name}
              </motion.h2>
              <motion.p
                className="text-base sm:text-lg font-light text-gray-600 transition-all duration-500 ease-in-out"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                {products[active].description}
              </motion.p>
              <motion.button
                onClick={() => navigate(products[active].url)}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className={`"inline-flex items-center px-5 py-2.5 ${products[active].color} text-white text-sm font-medium rounded-md shadow-md hover:${products[active].color}/40 transition`}
              >
                View More
              </motion.button>
            </motion.div>
          </div>
          <motion.div
            className="w-full overflow-hidden"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            <motion.div
              className="flex gap-[3%] w-full"
              animate={{ x: `-${active * 25}%` }}
              transition={{ type: "spring", stiffness: 180, damping: 20 }}
            >
              {displayProducts.map((product, idx) => (
                <div
                  key={`${product.id}-${idx}`}
                  onClick={() => setActive(idx % products.length)}
                  className={`flex-shrink-0 relative group rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ease-in-out ${
                    idx === active
                      ? "w-[75%]"
                      : "w-[22%] opacity-60 hover:opacity-90"
                  }`}
                >
                  <div
                    className={`${product.color} p-4 w-full md:min-h-[600px] md:h-full h-auto flex flex-col rounded-2xl shadow-xl relative`}
                  >
                    <div className="w-full relative md:min-h-[600px] md:h-full h-auto">
                      <img
                        src={product.img}
                        alt={product.name}
                        loading="lazy"
                        className="w-full md:min-h-[600px] md:h-full h-auto rounded-xl bg-white object-cover object-top"
                      />
                    </div>
                  </div>
                  {idx !== active && (
                    <div className="absolute inset-0 bg-black/10 backdrop-blur-[1px] rounded-2xl flex items-center justify-center">
                      <span className="text-white font-semibold text-sm bg-black/60 px-4 py-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        View Product
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}

export default OurProducts;
